import { Service } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useService = (
  id: number | undefined
): { service: Service | undefined; loading: boolean } => {
  const { serviceStore } = useStore();
  const { service, loading } = serviceStore;

  useEffect(() => {
    id && serviceStore.get({ id });

    return () => {
      serviceStore.clearService();
    };
  }, [serviceStore, id]);

  return { service, loading };
};
